import React from 'react';

import { Strong, Link } from '@constellation/core';
import { ChevronUp } from '@constellation/core/icons';

import { StyledDiv } from '../LimitedCompanyCriteria.styled';

interface BackToTopLinkProps {
  jumpToASectionId: string;
  dataTestId: string;
  children: string;
}

function BackToTopLink({
  jumpToASectionId,
  dataTestId,
  children,
}: BackToTopLinkProps) {
  return (
    <StyledDiv>
      <Link href={`#${jumpToASectionId}`} data-testid={dataTestId}>
        <Strong color="brand">
          {children}
          <ChevronUp color="default1" size="s3" />
        </Strong>
      </Link>
    </StyledDiv>
  );
}

export default BackToTopLink;
